/**
 * All API requests in this file are prefixed with REQUEST_BASE_URL.
 * This ensures consistency and makes it easy to update the base path for all related endpoints.
 *
 * Example:
 *   - fetchRequestTypes() calls /Request/Types
 *   - submitRequest() posts to /Request/Create
 *   - fetchLabelsByRequestType() calls /Request/Labels
 */

import { SearchOptions } from '../constants/app';
import { IAddRequest } from '../constants/interfaces';
import api from './client';

const REQUEST_BASE_URL = '/api/Request';

export async function fetchRequestTypes() {
  const response = await api.get(`${REQUEST_BASE_URL}/Types`);
  return response.data;
}

export async function submitRequest(data: IAddRequest) {
  const response = await api.post(`${REQUEST_BASE_URL}/Create`, data);
  return response.data;
}

export async function fetchLabelsByRequestType(requestTypeId: number) {
  const response = await api.get(`${REQUEST_BASE_URL}/Labels`, {
    params: { requestTypeId: requestTypeId },
  });
  return response.data;
}

export async function getRequests({
  searchText,
  selectedRequestType,
  selectedTimePeriod,
}: SearchOptions) {
  const response = await api.get(`${REQUEST_BASE_URL}/List`, {
    params: { searchText, selectedRequestType, selectedTimePeriod },
  });

  return response.data;
}
